import { AlertTriangle } from "lucide-react";
import type { ProcurementRevision } from "../../domain/request-detail-types";
import { revisionValue, dateTime } from "../requests/detail/request-detail-presentation";

export function RevisionComparison({
  revisions,
}: {
  revisions: ProcurementRevision[];
}) {
  if (!revisions.length) return null;
  return (
    <section className="revision-comparison" aria-labelledby="revision-heading">
      <header className="revision-comparison-header">
        <div>
          <span className="section-kicker">DENETİM İZİ</span>
          <h2 id="revision-heading">Revizyonda ne değişti?</h2>
          <p>Yalnızca önceki onaydan sonra değiştirilen bilgiler gösterilir.</p>
        </div>
        <span>{revisions.length} revizyon</span>
      </header>
      <div className="revision-history">
        {revisions.map((revision, index) => (
          <details key={revision.id} open={index === 0}>
            <summary>
              <strong>Revizyon {revision.revisionNumber}</strong>
              <span>{dateTime(revision.submittedAt)}</span>
              <span>{revision.changedBy}</span>
              <span>
                {revision.pendingFields.length
                  ? "Düzeltme bekliyor"
                  : "Tamamlandı"}
              </span>
            </summary>
            <div className="revision-body">
              <div className="revision-instruction">
                <span>Müdürün düzeltme talebi</span>
                <strong>{revision.correctionInstruction}</strong>
              </div>
              <p className="revision-impact">{revision.impactSummary}</p>
              {revision.pendingFields.length ? (
                <div className="revision-pending" role="alert">
                  <AlertTriangle size={17} />
                  Düzeltme bekliyor: {revision.pendingFields.join(", ")}
                </div>
              ) : null}
              <div className="revision-change-list">
                {revision.changes.map((change, changeIndex) => (
                  <article
                    key={`${change.field}-${change.offerNo}-${changeIndex}`}
                  >
                    <div className="revision-change-heading">
                      <div>
                        <strong>{change.field}</strong>
                        {!change.requested ? <span>Ek değişiklik</span> : null}
                      </div>
                      <small>
                        {change.supplier ?? "Talep"}
                        {change.offerNo ? ` · ${change.offerNo}` : ""}
                      </small>
                    </div>
                    <div className="revision-values">
                      <span>
                        <small>Önceki</small>
                        {revisionValue(change.previousValue)}
                      </span>
                      <span aria-hidden="true">→</span>
                      <span>
                        <small>Güncel</small>
                        {revisionValue(change.currentValue)}
                      </span>
                    </div>
                    {change.differenceAmount !== null ? (
                      <p>
                        Değişim: {change.differenceAmount > 0 ? "+" : ""}
                        {change.differenceAmount.toLocaleString("tr-TR")}
                        {change.differencePercent !== null
                          ? ` (%${Math.abs(change.differencePercent).toLocaleString("tr-TR", { maximumFractionDigits: 1 })})`
                          : ""}
                      </p>
                    ) : null}
                    {change.scoreBefore !== change.scoreAfter ||
                    change.rankBefore !== change.rankAfter ? (
                      <p className="revision-score-impact">
                        Sistem puanı:{" "}
                        {change.scoreBefore === null
                          ? "—"
                          : Math.round(change.scoreBefore)}{" "}
                        →{" "}
                        {change.scoreAfter === null
                          ? "—"
                          : Math.round(change.scoreAfter)}
                        {" · "}Sıralama: {change.rankBefore ?? "—"}. →{" "}
                        {change.rankAfter ?? "—"}.
                      </p>
                    ) : null}
                    <footer>
                      <span>{change.specialistExplanation}</span>
                      <small>
                        {change.changedBy} · {dateTime(change.changedAt)}
                      </small>
                    </footer>
                  </article>
                ))}
              </div>
            </div>
          </details>
        ))}
      </div>
    </section>
  );
}
